<template>
    <div class='logo-container' @click='goToHome'>
        <img class="logo" :class="{'desktop': logged_in}" src="/images/logos/majestic-commercial-logo-2.png" />
        <img v-show='logged_in' class="logo mobile" src="/images/logos/majestic-logo-round.png" />
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    props: ['logged_in'],
    data(){
        return{
            logo: 'logo-new1.png'
        }
    },
    methods:{
        goToHome(){
            if(this.logged_in) {
                window.location.href = "/list?list_type=customer_list";
            } else {
                window.location.href = "/";
            }
            // this.$router.push('/');
        }
    }
}
</script>

<style lang="scss" scoped>
.logo-container{
    padding: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.logo{
    height: 100px;

    @media(max-width: 1562px){
        height: 60px;
    }

    @media(max-width: 1315px){
        height: 50px;
    }

     @media(max-width: 1200px){
        height: 40px;
    }

    @media(max-width: 1100px){
        height: 60px;
    }
    
    @media(max-width: 768px){
        height: 60px;
    }
}

.logo.mobile{
    @media(min-width: 768px){
        display: none;
    }
}
.logo.desktop{
    @media(max-width: 768px){
        display: none;
    }
}
</style>